// gui/src/config/claude.ts

export const CLAUDE_MODELS = {
  // ✅ SUPPORTED MODELS (matches backend claude_config.py):
  // - expert:     claude-sonnet-4-6 (all plans)
  // - genius:     claude-opus-4-7   (Basic and above)
  // - uncensored: grok/grok-4-1-fast-reasoning (Basic and above)

  // Haiku 4.5 — kept for legacy alias resolution only (not shown in UI)
  HAIKU_4_5: 'claude-haiku-4-5',

  // Sonnet 4.6 — Expert (all plans)
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',

  // Opus 4.7 — Genius (Basic and above)
  CLAUDE_OPUS_4_7: 'claude-opus-4-7',

  // Sonnet 4.5 — kept for compatibility
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',

  // Legacy aliases — kept for backward compatibility; resolve via backend resolve_claude_model
  CLAUDE_35_SONNET: 'claude-haiku-4-5',
  BEST: 'claude-haiku-4-5',
  FAST: 'claude-haiku-4-5',
  INSTANT: 'claude-haiku-4-5',
  LEGACY: 'claude-haiku-4-5',
};

// Legacy sentinel — used only to detect stale persisted Haiku spaces and upgrade them to Expert.
export const DEFAULT_CLAUDE_MODEL = 'claude-haiku-4-5';

// ✅ Default model for all plans
export const DEFAULT_EXPERT_MODEL = 'claude-sonnet-4-6';

// ✅ ONLY SUPPORTED MODELS - matches backend config
export const AVAILABLE_CLAUDE_MODELS = [
  { id: CLAUDE_MODELS.CLAUDE_SONNET_4_6, name: 'Claude Sonnet 4.6 (Whiz)' },
  { id: CLAUDE_MODELS.CLAUDE_OPUS_4_7, name: 'Claude Opus 4.7 (Genius — Basic+)' },
];

// Combined list of all available models (Claude + other providers)
import { AVAILABLE_VENICE_MODELS } from './venice';
import { AVAILABLE_GROK_MODELS } from './grok';

export const ALL_AVAILABLE_MODELS = [
  ...AVAILABLE_CLAUDE_MODELS,
  ...AVAILABLE_VENICE_MODELS,
  ...AVAILABLE_GROK_MODELS,
];

